import { render, staticRenderFns } from "./VehicleHistory.vue?vue&type=template&id=82662c2c&"
import script from "./VehicleHistory.vue?vue&type=script&lang=js&"
export * from "./VehicleHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports